<template>
  <div>
    <v-layout row class="mt-4 align-center justify-center row fill-height"
    v-if="this.getSearchResults.length === 0">
      <v-card :class="ui.bkgdColor" :max-width="ui.cardMinWidth">
        <v-card-title primary-title>
          <v-layout row>
            <v-icon left :class="ui.chipColor"> warning </v-icon>
            <a :class="ui.textTitle">
              Access Data
            </a>
          </v-layout>
        </v-card-title>
        <v-layout row class="ml-4 mr-4  mb-4 mt-4">
          <a :class="ui.textSubheading">
            Please contact Admin for info.
          </a>
        </v-layout>
      </v-card>
    </v-layout>
    <div v-else>
      <v-layout row class="mt-4">
        <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
          <v-layout row>
            <v-btn :color="ui.btnColor" flat dark :to="this.headerObj.router">
              <v-icon left> {{ this.headerObj.icon }} </v-icon>
              {{ this.headerObj.title }}
            </v-btn>
            <v-spacer/>
            <v-btn :color="ui.colorBlue" flat dark
            class="hidden-xs-only"
            v-if="this.headerObj.accessLock === true">
              <v-icon :color="ui.colorBlue"> lock </v-icon>
            </v-btn>
            <v-btn :color="ui.colorBlue" flat dark>
              <v-icon left :color="ui.colorBlue"> person </v-icon>
                {{this.getSearchResults.length}}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row class="mt-1">
        <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
          <v-data-table
          :headers="headers"
          :items="getSearchResults"
          class="elevation-1"
          :total-items=this.maxRows
          :hide-actions=this.hideActions
          >
           <template slot="items" slot-scope="props">
             <td class="text-xs-left">
               {{ displayDocumentIDGTypeA(props.item.basic.tag, props.item.basic.idg) }}
             <td class="text-xs-left">
               {{ defineTableData(props.item).auth }}
             </td>
             <td class="text-xs-left">
               {{ defineTableData(props.item).name }}
             </td>
             <td class="text-xs-left">
               <span v-if="props.item.trans.hist.length > 0">
                 {{ dateTimeAgo(props.item.trans.hist[props.item.trans.hist.length - 1].date) }}
               </span>
               <span v-else>
                 {{ dateTypeA(props.item.stats.dcrt) }}
               </span>
             </td>
             <td class="text-xs-left">
               {{ defineStatus(props.item) }}
             </td>
             <!-- {{props.item.trans.stat}} -->
             <td class="text-xs-right">
               <v-layout row>
                 <v-spacer/>
                 <AccessSelect :listIndex="props.index"/>
               </v-layout>
             </td>
           </template>
         </v-data-table>
       </v-flex>
     </v-layout>
     <v-layout row>
       <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
         <v-layout row>
           <!-- LOAD NEXT IS NOT WORK FOR USER -->
           <div v-if="btnSpinLoadMore === false">
             <v-btn
             @click="loadNext()"
             :color="ui.colorBlue"
             :disabled="true"
             flat dark>
               <v-icon left :color="ui.colorBlue"> group_add </v-icon>
                 more users
             </v-btn>
           </div>
           <div v-else>
             <BtnSpin dark :btnSpec="btnInfo1"/>
           </div>
           <v-spacer/>
           <GetAccessListPage :data="{tag: tagObj.tag, tagd: tagObj.tagd, tags: tagObj.tags}"/>
         </v-layout>
       </v-flex>
     </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import AccessSelect from "@/support/access/components/AccessSelect";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";

export default {
  components: {
    AccessSelect,
    BtnSpin,
    GetAccessListPage
  },
  // eslint-disable-next-line
  mixins: [
    dateFunctions,
    numberFunctions,
    apptheme,
    displayFunctions,
    getList
  ],
  data() {
    return {
      maxRows: -1,
      hideActions: true,
      barMovement: false,
      btnSpinLoadMore: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  props: {
    date: {
      type: Object
    }
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    },
    defineTag(item) {
      let tag = item.basic.tag;
      return tag;
    },
    defineAuthLevel(item) {
      let auth = null;
      let tags = item.basic.tags;
      if (tags === "C1") {
        auth = item.select.cauth;
      } else {
        auth = item.select.fauth;
      }
      return auth;
    },
    defineStatus(item) {
      // let tag = item.basic.tag;
      // let level = item.trans.level;
      // let hold = item.trans.stat.hold;
      let txt = null;
      let status = item.trans.flow[item.trans.flow.length - 1].title;
      let lock = item.basic.lock;
      if (lock === true) {
        txt = "Locked";
      } else {
        txt = status;
      }
      return txt;
    },
    defineTableData(item) {
      let tag = item.basic.tag;
      let tagd = item.basic.tagd;
      let tags = item.basic.tags;
      let obj = {
        name: "",
        auth: ""
      };
      if (tag === "G1" && tagd === "C1" && tags === "U1") {
        obj.name = item.char.utitle;
        if (item.select.cauth === null) {
          obj.auth = item.trans.hist[item.trans.hist.length - 1].title;
        } else {
          obj.auth = item.select.cauth;
        }
      } else if (tag === "G1" && tagd === "U1" && tags === "C1") {
        obj.name = item.char.title;
        if (item.select.cauth === null) {
          obj.auth = item.trans.hist[item.trans.hist.length - 1].title;
        } else {
          obj.auth = item.select.cauth;
        }
      } else if (tag === "G1" && tagd === "Z5" && tags === "C1") {
        obj.name = item.char.title;
        if (item.select.cauth === null) {
          obj.auth = item.trans.hist[item.trans.hist.length - 1].title;
        } else {
          obj.auth = item.select.cauth;
        }
      } else if (tag === "G1" && tagd === "U1" && tags === "F1") {
        obj.name = item.char.title;
        if (item.select.fauth === null) {
          obj.auth = item.trans.hist[item.trans.hist.length - 1].title;
        } else {
          obj.auth = item.select.fauth;
        }
      } else if (tag === "G1" && tagd === "F1" && tags === "U1") {
        obj.name = item.char.utitle;
        if (item.select.fauth === null) {
          obj.auth = item.trans.hist[item.trans.hist.length - 1].title;
        } else {
          obj.auth = item.select.fauth;
        }
      } else {
        obj.name = "Undefined";
        obj.auth = "Undefined";
      }
      return obj;
    }
  },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getUser",
      "getFacility",
      "getPageTitle",
      "getDataSource"
    ]),
    tagObj() {
      let obj = {
        tag: null,
        tagd: null,
        tags: null
      };
      obj.tag = this.getSearchResults[0].basic.tag;
      obj.tagd = this.getSearchResults[0].basic.tagd;
      obj.tags = this.getSearchResults[0].basic.tags;
      return obj;
    },
    headerObj() {
      // DEFINE
      let obj = {
        router: "userdash",
        icon: "home",
        title: "Home Page",
        accessLock: false
      };
      let tag = this.getSearchResults[0].basic.tag;
      let tagd = this.getSearchResults[0].basic.tagd;
      let tags = this.getSearchResults[0].basic.tags;
      if (tag === "G1" && tagd === "Z5" && tags === "C1") {
        obj.title = "Company Admin Register";
        obj.icon = "account_balance";
        obj.router = "admindash";
      } else if (tag === "G1" && tagd === "U1" && tags === "C1") {
        obj.title = "Company Access Register";
        obj.icon = "person";
        obj.router = "userdash";
        if (this.getUserStats.alockc === true) {
          obj.accessLock = true;
        }
      } else if (tag === "G1" && tagd === "C1" && tags === "U1") {
        obj.title = "Company Users Register";
        obj.icon = "account_balance";
        obj.router = "companydash";
      } else if (tag === "G1" && tagd === "U1" && tags === "F1") {
        obj.title = "Facility Access Register";
        obj.icon = "person";
        obj.router = "userdash";
        if (this.getUserStats.alockf === true) {
          obj.accessLock = true;
        }
      } else if (tag === "G1" && tagd === "F1" && tags === "U1") {
        obj.title = "Facility Users Register";
        obj.icon = "place";
        obj.router = "facilitydash";
      } else {
        obj.title = "Undefined";
      }
      return obj;
    },
    headers() {
      let table = [
        { text: "ID", sortable: false },
        { text: "Auth", sortable: false },
        { text: "TBA", sortable: false },
        { text: "Updated", sortable: false },
        { text: "Status", sortable: false },
        // { text: "Status", sortable: false, value: "name" },
        { text: "", sortable: false, align: "right" }
      ];
      // let title = null;
      if (this.getSearchResults.length > 0) {
        let tag = this.getSearchResults[0].basic.tag;
        let tagd = this.getSearchResults[0].basic.tagd;
        let tags = this.getSearchResults[0].basic.tags;
        // CHECK
        if (tag === "G1" && tagd === "Z5" && tags === "C1") {
          table[2].text = "Company";
        } else if (tag === "G1" && tagd === "F1") {
          table[2].text = "User";
        } else if (tag === "G1" && tagd === "U1" && tags === "C1") {
          table[2].text = "Company";
        } else if (tag === "G1" && tagd === "C1" && tags === "U1") {
          table[2].text = "User";
        } else if (tag === "G1" && tagd === "U1" && tags === "F1") {
          table[2].text = "Facility";
        } else if (tag === "G1" && tagd === "F1" && tags === "U1") {
          table[2].text = "User";
        } else {
          table[2].text = "Undefined";
        }
      }
      return table;
    }
  }
};
</script>
